function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as F } from "react/jsx-runtime";
import * as n from "react";
import { useFieldProps as b } from "./form-context.js";
import { TextFieldBaseAutosuggest as j } from "./text-field-base.js";
import { combineRefs as k } from "./utils/common.js";
import { createChangeEvent as w } from "./utils/dom.js";
import { useIsomorphicLayoutEffect as A } from "./hooks.js";
const C = (c, t, r, i)=>{
    A(()=>{
        c && t && r && t.length > r && i && i(w(c, t.slice(0, r)));
    }, [
        i,
        t,
        r,
        c
    ]);
}, H = /*#__PURE__*/ n.forwardRef((_param, g)=>{
    var { disabled: c , error: t , helperText: r , name: i , optional: m , validate: a , onChangeValue: p , onChange: d , value: R , defaultValue: T , onBlur: l , onFocus: u , onPress: x  } = _param, s = _object_without_properties(_param, [
        "disabled",
        "error",
        "helperText",
        "name",
        "optional",
        "validate",
        "onChangeValue",
        "onChange",
        "value",
        "defaultValue",
        "onBlur",
        "onFocus",
        "onPress"
    ]);
    const e = n.useRef(null), v = (o)=>o, h = (o)=>{
        s.multiline && e.current && (e.current.scrollTop = 0), l == null || l(o);
    }, y = (o)=>{
        s.multiline && setTimeout(()=>{
            if (e.current) {
                const E = e.current.value;
                e.current.value = "", e.current.value = E, e.current.scrollTop = e.current.scrollHeight;
            }
        }, 0), u == null || u(o);
    }, f = b({
        name: i,
        value: R,
        defaultValue: T,
        processValue: v,
        helperText: r,
        optional: m,
        error: t,
        disabled: c,
        onBlur: h,
        validate: a,
        onChange: d,
        onChangeValue: p
    });
    return C(e.current, f.value, s.maxLength, f.onChange), /* @__PURE__ */ F(j, _object_spread_props(_object_spread({}, s, f), {
        onClick: x,
        inputRef: k(e, f.inputRef, g),
        onFocus: y,
        type: "text"
    }));
}), z = H;
export { z as default };
